var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-view',[_c('div',{attrs:{"slot":"header"},slot:"header"}),_c('div',{staticClass:"wrap-container-in text-center"},[_vm._v("\n    暂无内容，请先浏览其他页面~\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }